import {
  ref,
  computed,
  reactive,
  // watch,
  // xxx
} from '@vue/composition-api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import axios from 'axios'
import {
  URL,
  INSERT_DATA_PLAYER,
  INSERT_DATA_HISTORY_PLAYER,
  UPDATE_DATA_PLAYER,
  ESTADO_JUGADOR,
} from '../../utils/variables'
import apiCall from '../../utils/apiCall'

export default function useInscription() {
  const { getApi, postApi } = apiCall()
  const listEquipos = ref([])
  const listJugadores = ref([])
  const listJugadoresSearch = ref([])
  const listCategoriasAdmin = ref([])
  const listPositions = ref([])
  const listTiposAdicionales = ref([])
  const listHistorialCampeonatos = ref([])
  const searchQuery = ref('')
  const listInstitutions = ref([])
  // const totalInscritos= ref(0)
  // const totalRevisados= ref(0)
  const categoriaAdmin = ref(null)
  const categoriaSeleccionada = ref({ label: 'Seleccione Equipo', isInReview: false })
  const refInvoiceListTable = ref(null)
  const showLoading = ref(false)
  const playerData = reactive({
    apellidos: '',
    ci_pasaporte: '',
    direccion: null,
    email: null,
    fecha_nac: '',
    id_disciplina: '',
    id_equipo: '',
    nombres: '',
    num_camiseta: '',
    id_historial: '',
    observaciones: null,
    posicion: {
      label: 'Posicion',
      value: null,
    },
    tipo_adicional: {
      label: 'Tipo Jugador',
      value: null,
    },
    posicionAuxiliar: {
      label: 'Posicion',
      value: null,
    },
    institucion: {
      label: 'Seleccione Institucion',
      value: null,
    },
    telefono: null,
    tipo_jugador: '',
    estado_jug: 'inscrito',
    id_jugador: null,
    vacuna: null,
    dataCategoria: {
      facialWeb: false,
    },
  })
  // const playerSelected = reactive({})

  const tableColumns = [
    { key: 'jugador', label: 'Delegado', sortable: true },
    { key: 'institucion_tabla', label: 'Institucion', sortable: true },
    { key: 'acciones' },
  ]

  async function getJugadores(idCampeonato) {
    listJugadores.value = []
    showLoading.value = true
    const path = `ApiInscripciones/getDelegadosInstituciones/${idCampeonato}`
    const data = await getApi(URL, path)
    listJugadores.value = data.data
    showLoading.value = false
  }
  async function getInstituciones(idTorneo) {
    listInstitutions.value = []
    const path = `ApiUsuario/getInstituciones/${idTorneo}`
    const data = await getApi(URL, path)
    if (data.flag === 's') {
      data.data.forEach(element => {
        const obj = {
          label: element.nombre,
          value: element.id_institucion,
          id_disciplina: element.id_disciplina,
        }
        listInstitutions.value.push(obj)
      })
    } else {
      listInstitutions.value = []
    }
  }
  async function getJugadoresCedula(cedula, idDisciplina) {
    listJugadoresSearch.value = []
    const path = `ApiInscripciones/getJugadoresCedula/${cedula}/${idDisciplina}`
    const data = await getApi(URL, path)
    if (data.flag === 'si') {
      listJugadoresSearch.value = data.data
    } else {
      listJugadoresSearch.value = []
    }
  }
  const listPlayersFilter = computed(() => listJugadores.value.filter(
    player => player.nombres
      .toLowerCase()
      .includes(searchQuery.value.toLowerCase())
      // eslint-disable-next-line
      || player.apellidos
        .toLowerCase()
        .includes(searchQuery.value.toLowerCase())
      // eslint-disable-next-line
      || player.ci_pasaporte
        .toLowerCase()
        .includes(searchQuery.value.toLowerCase()),
  ))

  const totalCalificados = computed(() => listPlayersFilter.value.filter(element => element.estado_jug === ESTADO_JUGADOR.CALIFICADO && element.is_activo === true).length)
  const totalRevisados = computed(() => listPlayersFilter.value.filter(element => element.estado_jug === ESTADO_JUGADOR.REVISADO).length)
  const totalInscritos = computed(() => listPlayersFilter.value.filter(element => element.estado_jug === ESTADO_JUGADOR.INSCRITO).length)
  const totalInactivos = computed(() => listPlayersFilter.value.filter(element => element.estado_jug === ESTADO_JUGADOR.CALIFICADO && element.is_activo === false).length)

  async function updateFacialId(item) {
    const path = 'ApiInscripciones/updateFacialId'
    const data = { id_jugador: item.id_jugador }
    const response = await postApi(URL, path, data)
    if (response.flag === 'si') {
      const found = listPlayersFilter.value.findIndex(
        // eslint-disable-next-line
        element => element.id_jugador === item.id_jugador
      )
      listPlayersFilter.value[found].have_face = true
      // listCategorias.value[found].valores_fijos.push(item)
      // console.log(playerData)
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Facial Id generado',
            icon: 'AlertCircleIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'top-center',
          // eslint-disable-next-line
        }
      )
    } else {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: `ERROR ${response.mensaje}`,
            icon: 'AlertCircleIcon',
            variant: 'danger',
            solid: true,
          },
        },
        {
          position: 'top-center',
          // eslint-disable-next-line
        }
      )
    }
  }
  function getTotal() {
    const list = listPlayersFilter.value.filter(element => element.estado_jug === ESTADO_JUGADOR.CALIFICADO)
    return list.length
  }

  return {
    tableColumns,
    listEquipos,
    listJugadores,
    listCategoriasAdmin,
    getJugadores,
    searchQuery,
    refInvoiceListTable,
    listPlayersFilter,
    getJugadoresCedula,
    listJugadoresSearch,
    listPositions,
    listTiposAdicionales,
    // playerSelected,
    playerData,
    INSERT_DATA_PLAYER,
    INSERT_DATA_HISTORY_PLAYER,
    UPDATE_DATA_PLAYER,
    categoriaAdmin,
    showLoading,
    // updateSolicitudRevision,
    categoriaSeleccionada,
    getTotal,
    totalCalificados,
    totalRevisados,
    totalInscritos,
    totalInactivos,
    listHistorialCampeonatos,
    updateFacialId,
    getInstituciones,
    listInstitutions,
    // uploadExcel,
    // uploadExcel,
  }
}
